var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4698_20330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H4.375V4.375H0V0ZM0.625 0.625H3.75V1.25H0.625V0.625Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0H9.375V4.375H5V0ZM5.625 0.625H8.75V3.125H5.625V0.625Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.375 0H10V4.375H14.375V0ZM13.75 0.625H10.625V3.75H13.75V0.625Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5H4.375V9.375H0V5ZM0.625 5.625H3.75V7.5H0.625V5.625Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 5H5V9.375H5.66931C5.80855 8.40153 6.26826 7.53143 6.93814 6.875H5.625V5.625H8.75V5.80617C8.95257 5.74589 9.1613 5.69987 9.375 5.66931V5Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3307 9.375H14.375V5H10V5.625C10.2122 5.625 10.4209 5.64011 10.625 5.66931V5.625H13.75V7.74526C14.0447 8.23431 14.2464 8.78572 14.3307 9.375Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.375C12.4162 14.375 14.375 12.4162 14.375 10V14.375H10Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 10H5V14.375H9.375V14.3307C7.67265 14.0872 6.28643 12.8637 5.80617 11.25H5.625V10.625H5.66931C5.64011 10.4209 5.625 10.2122 5.625 10Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 10H0V14.375H4.375V10ZM3.75 10.625H0.625V13.125H3.75V10.625Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15ZM10 14.375C12.4162 14.375 14.375 12.4162 14.375 10C14.375 7.58375 12.4162 5.625 10 5.625C7.58375 5.625 5.625 7.58375 5.625 10C5.625 12.4162 7.58375 14.375 10 14.375Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.875H10.625V13.125H9.375V6.875Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 9.375H13.125V10.625H6.875V9.375Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4698_20330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddScreen);
export default __webpack_public_path__ + "static/media/AddScreen.e1a4636b3f57f98f61c3190a3fdb759c.svg";
export { ForwardRef as ReactComponent };